module.exports = __webpack_public_path__ + "img/okaka.3f1bb7c0.png";